/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_My_CollectionInputs */

const en_tab_my_collection = /** @type {(inputs: Tab_My_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Collection`)
};

const ar_tab_my_collection = /** @type {(inputs: Tab_My_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجموعتي`)
};

const de_tab_my_collection = /** @type {(inputs: Tab_My_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Sammlung`)
};

const es_tab_my_collection = /** @type {(inputs: Tab_My_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi colección`)
};

const fr_tab_my_collection = /** @type {(inputs: Tab_My_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ma collection`)
};

const it_tab_my_collection = /** @type {(inputs: Tab_My_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La mia collezione`)
};

const ja_tab_my_collection = /** @type {(inputs: Tab_My_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイコレクション`)
};

const ko_tab_my_collection = /** @type {(inputs: Tab_My_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 컬렉션`)
};

const pt_br_tab_my_collection = /** @type {(inputs: Tab_My_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minha Coleção`)
};

const ru_tab_my_collection = /** @type {(inputs: Tab_My_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Моя коллекция`)
};

const th_tab_my_collection = /** @type {(inputs: Tab_My_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คอลเลกชันของฉัน`)
};

const tr_tab_my_collection = /** @type {(inputs: Tab_My_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koleksiyonum`)
};

const zh_cn_tab_my_collection = /** @type {(inputs: Tab_My_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收藏柜`)
};

const zh_tw_tab_my_collection = /** @type {(inputs: Tab_My_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收藏櫃`)
};

/**
* | output |
* | --- |
* | "My Collection" |
*
* @param {Tab_My_CollectionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tab_my_collection = /** @type {((inputs?: Tab_My_CollectionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_My_CollectionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tab_my_collection(inputs)
	if (locale === "ar") return ar_tab_my_collection(inputs)
	if (locale === "de") return de_tab_my_collection(inputs)
	if (locale === "es") return es_tab_my_collection(inputs)
	if (locale === "fr") return fr_tab_my_collection(inputs)
	if (locale === "it") return it_tab_my_collection(inputs)
	if (locale === "ja") return ja_tab_my_collection(inputs)
	if (locale === "ko") return ko_tab_my_collection(inputs)
	if (locale === "pt_br") return pt_br_tab_my_collection(inputs)
	if (locale === "ru") return ru_tab_my_collection(inputs)
	if (locale === "th") return th_tab_my_collection(inputs)
	if (locale === "tr") return tr_tab_my_collection(inputs)
	if (locale === "zh_cn") return zh_cn_tab_my_collection(inputs)
	return zh_tw_tab_my_collection(inputs)
});